import React, { forwardRef } from 'react';
import {
    styled,
    Dialog as MUIDialog,
    DialogTitle,
    DialogContent,
    DialogActions as MUIDialogActions,
} from '@mui/material';

import Box from 'shell/components/Box';

const CustomDialog = styled(MUIDialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
    },
}));

const DialogActions = styled(MUIDialogActions)(({ theme }) => {
    return {
        padding: theme.spacing(3, 7),
    };
});

const CustomBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(8),
}));

const Dialog = forwardRef(({ children, scroll, ...rest }, ref) => {
    return (
        <CustomDialog ref={ref} {...rest}>
            {scroll ? children : <CustomBox>{children}</CustomBox>}
        </CustomDialog>
    );
});

export { Dialog, DialogTitle, DialogContent, DialogActions };
